import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";
import HeadingTexts from "../../common/HeadingTexts";


const Book = () => {
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    gender: "",
    DOB: "",
    speciality: "",
    query: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (message) setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    // console.log(formData)
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/inquiries/send-inquiry`, formData); 
      // console.log(response.data)
      if (response.status === 201) {
        toast.success("Enquiry submitted successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          gender: "",
          DOB: "",
          speciality: "",
          query: "",
        });
        setMessage("Thank you! We'll get back to you soon.");
      }
    } catch (error) {
      console.error("Error submitting enquiry:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className=" md:px-10 px-6 bg-[#fafafa]">
      <div className="flex lg:flex-row flex-col justify-between items-center mb-8 md:gap-20 gap-10">
        <div className="lg:w-1/2 w-full">
          <HeadingTexts label={'BOOK AN APPOINTMENT'} text={'Effortless Online Booking for'} bluetext={'Your Laboratory Visit'} />
          <form className="space-y-4 mt-5" onSubmit={handleSubmit}>
            <div className="flex space-x-4">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-1">Your Name</label>
                <input onChange={handleChange} value={formData.firstName} name="firstName"
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primaryColor"
                  placeholder="Your Name"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                <input onChange={handleChange} value={formData.email} name="email"
                  type="email"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primaryColor"
                  placeholder="Email Address"
                />
              </div>
            </div>
            <div className="flex space-x-4">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                <input onChange={handleChange} value={formData.phone} name="phone"
                  type="tel"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primaryColor"
                  placeholder="Phone number"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-1">Select Service</label>
                <select onChange={handleChange} value={formData.speciality} name="speciality" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primaryColor">
                  <option value="">Select Service</option>
                  <option value="Clinical Biochemistry">Clinical Biochemistry</option>
                  <option value="Hematology Tests">Hematology Tests</option>
                  <option value="Microbiology & Infectious Disease Testing">Microbiology & Infectious Disease Testing</option>
                  <option value="Histopathology & Cytopathology">Histopathology & Cytopathology</option>
                  <option value="Molecular & Genetic Testing">Molecular & Genetic Testing</option>
                </select>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
              <textarea name="query" onChange={handleChange} value={formData.query}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primaryColor h-24"
                placeholder="Write your message"
              ></textarea>
            </div>
            <button
              type="submit"
              className="bg-primaryColor text-white familjen-font py-3 px-6 rounded-md font-semibold hover:bg-[#0a9bb5] transition-colors"
            >
              {loading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Submitting...
                </>
              ) : (
                "MAKE APPOINTMENT"
              )}
            </button>
          </form>
          {message && (
            <div
              className={`px-6 pb-6 text-center text-sm mt-5 transition-all duration-300 ${message.includes("success") || message.includes("Thank")
                ? "text-green-600"
                : "text-red-600"
                }`}
            >
              {message}
            </div>
          )}
        </div>
        <div className="lg:w-1/2 w-full flex flex-col lg:px-10">
          <p data-aos="fade-up" data-aos-duration="700" className="text-gray-700 mb-6 leading-relaxed">
            We believe in a future where renewable energy sources play a vital role in reducing carbon emissions. we provide a wide range of diagnostic services ranging from complete health check-up packages.
          </p>
          <div data-aos="fade-up" data-aos-duration="700" className="bg-primaryColor text-white p-6 rounded-lg">
            <h4 className="text-xl font-semibold familjen-font mb-4">Clinic hours</h4>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span>Mon - Tue</span>
                <span>06:00AM -09:00PM</span>
              </div>
              <div className="flex justify-between">
                <span>Wed - Thu</span>
                <span>06:00AM -09:00PM</span>
              </div>
              <div className="flex justify-between">
                <span>Fri - Sat</span>
                <span>06:00AM -09:00PM</span>
              </div>
              <div className="flex justify-between pt-2 border-t border-white/20">
                <span>Emergency</span>
                <span>24/7 hours 7 days</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Book;